<div mat-dialog-title>

  <h1 class="titulo-simpli">Adjunta tu Certificado Digital Electrónico</h1>
  <small class="subtitulo-simpli">También debes ingresar el RUT del titular y la clave asociada.</small>

  <div class="btn_cerrar" mat-dialog-close>

    <span class="material-symbols-outlined">close</span>

  </div>

</div>

<div mat-dialog-content>
  <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
    <mat-card class="animate__animated animate__fadeIn" style="border: none;box-shadow: none !important;">

      <mat-card-content>

        <form  [formGroup]="valForm" >

          <div class="row">


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

              <mat-form-field appearance="fill" color="primary">
                <mat-label>Facturador Electrónico</mat-label>
                <input  matInput formControlName="facturador" [matAutocomplete]="auto" [formControl]="stateCtrl" (change)="validate($event)">
                <mat-autocomplete #auto="matAutocomplete" class="add_factoring" (optionSelected)="set_facturador($event)">
                  @for (state of filteredStates | async; track state) {
                    <mat-option [value]="state.name" >
                      @if (state.flag != null) {
                        <img class="example-option-img" aria-hidden [src]="state.flag" height="25">
                      }
                      @if (state.flag == null) {
                        <mat-label style="font-size: 16px;font-weight: bold;color:#1b0943;">Utilizo otro Facturador</mat-label>
                      }
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (saving_facturador) {
                  <mat-spinner diameter="20" color="primary" matSuffix></mat-spinner>
                }
                @if (success_facturador) {
                  <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color:#3BA46F;">check_circle</mat-icon>
                }
                <mat-hint>Selecciona tu facturador electrónico</mat-hint>
              </mat-form-field>


              @if (mostrar_form == true) {
                <mat-form-field color="primary" appearance="fill">
                  <mat-label>Nombre Facturador</mat-label>
                  <input matInput formControlName="otro_facturador" (change)="escribio_otro()">
                  @if (success_facturador_otro) {
                    <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color:#3BA46F;">check_circle</mat-icon>
                  }
                  <mat-hint>Indique el nombre de su Facturador Electrónico</mat-hint>
                </mat-form-field>
              }

              @if (mostrar_form2) {
                <mat-form-field color="primary" appearance="fill">
                  <mat-label>Usuario Nubox</mat-label>
                  <input required matInput formControlName="rut_nubox" >
                  @if (saving_facturador_nubox) {
                    <mat-spinner color="primary" diameter="20" matSuffix ></mat-spinner>
                  }
                  <mat-hint>Indique el usuario de su facturador Nubox</mat-hint>
                  @if (valForm.controls['rut_nubox'].hasError('required')) {
                    <mat-error>
                      El usuario es requerido.
                    </mat-error>
                  }
                </mat-form-field>
              }

              @if (mostrar_form2) {
                <mat-form-field color="primary" appearance="fill">
                  <mat-label>Contraseña Nubox</mat-label>
                  <input required matInput formControlName="clave_nubox"  type="password"   >
                  @if (saving_facturador_nubox) {
                    <mat-spinner color="primary" diameter="20" matSuffix></mat-spinner>
                  }
                  @if (success_facturador_nubox) {
                    <mat-icon matSuffix class="animate__animated animate__fadeIn" style="color:#3BA46F;">check_circle</mat-icon>
                  }
                  <mat-hint>Indique la contraseña de su facturador Nubox</mat-hint>
                  @if (valForm.controls['clave_nubox'].hasError('required')) {
                    <mat-error>
                      La contraseña es requerida.
                    </mat-error>
                  }
                </mat-form-field>
              }





            </div>


          </div>



        </form>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <div [ngClass]="{'disable-btn':disable_btn == true, 'btn-simpli-container':true}">

        @if (mostrar_put_nubox==true) {
          <button  [disabled]="disable_btn"  mat-flat-button class="primary-button" type="button" style="margin-top: 10px;" (click)="submitForm($event, valForm.value)">
            @if (!disable_btn) {
              <mat-label>Guardar</mat-label>
            }
            @if (disable_btn) {
              <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
            }
          </button>
        }
        @if (mostrar_put_nubox==false) {
          <button  [disabled]="disable_btn"  mat-flat-button class="primary-button" type="button" style="margin-top: 10px;" (click)="put_facturador()">
            @if (!disable_btn) {
              <mat-label>Guardar</mat-label>
            }
            @if (disable_btn) {
              <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
            }
          </button>
        }

      </div>

    </div>
  </div>

</div>
